<template>
  <div class="cd_report-fish-form pr-4">
    <form ref="reportFish" @submit.stop.prevent="createFishReport">
      <div class="form-row">
        <div class="col">
          <label for="email">Email address (optional)</label>
          <input type="email" class="form-control" name="email" id="email" aria-describedby="emailHelp" placeholder="Enter email">
          <small id="emailHelp" class="form-text text-muted">We'll never share your email.</small>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <label for="lng">Longitude</label>
          <input type="number" step="0.001" :value="this.center.lat" name="lng" class="form-control" id="lng" aria-describedby="lngHelp" placeholder="Loading Longitude...">
          <small id="lngHelp" class="form-text text-muted">Longitude will load based on your current location or by dragging the marker on the map.</small>
        </div>
        <div class="col">
          <label for="lat">Latitude</label>
          <input type="number" step="0.001" :value="this.center.lng" name="lat" class="form-control" id="lat" aria-describedby="latHelp" placeholder="Loading Latitude...">
          <small id="latHelp" class="form-text text-muted">Latitude will load based on your current location or by dragging the marker on the map.</small>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <label for="category">Species</label>
            <select class="form-control" id="category">
              <option>Brown Trout</option>
              <option>Small Mouth Bass</option>
              <option>Large Mouth Bass</option>
              <option>Blue Gill Sunfish</option>
              <option>Green Sunfish</option>
              <option>Pumpkin Seed Sunfish</option>
              <option>Creek Chub</option>
              <option>Yellow Bullhead Catfish</option>
              <option>Unsure / Other</option>
            </select>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <label for="length">Length in inches</label>
          <input type="number" step="0.01" name="length" class="form-control" id="length" aria-describedby="lengthHelp" placeholder="Length">
          <small id="lengthHelp" class="form-text text-muted">Length measured by ruler in inches.  Please do not estimate, leave blank if unknown.</small>
        </div>
        <div class="col">
          <label for="weight">Weight in ounces</label>
          <input type="number" step="0.01" name="weight" class="form-control" id="weight" aria-describedby="weightHelp" placeholder="Weight">
          <small id="weightHelp" class="form-text text-muted">Measured by scale.  Please do not estimate, leave blank if unknown.</small>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <label for="description">Description of Fish Health</label>
          <textarea name="description" class="form-control" id="description" rows="3" aria-describedby="descriptionHelp"></textarea>
          <small id="descriptionHelp" class="form-text text-muted">Describe the fish's overall visual health, notice any lesions or scaring.</small>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
             <label for="file">Upload Image</label>
             <input type="file" class="form-control-file" id="file" name="file" aria-describedby="fileHelp">
             <small id="fileHelp" class="form-text text-muted">Please upload clear and focused pictures.</small>
           </div>
        </div>
      </div>
      <button type="submit" class="btn btn-secondary">Submit</button>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'ReportFishForm',
    props: {
      center: Object
    }
  }
</script>
